import { render, staticRenderFns } from "./LeaveInformation.vue?vue&type=template&id=470b65db&scoped=true"
import script from "./LeaveInformation.vue?vue&type=script&lang=js"
export * from "./LeaveInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470b65db",
  null
  
)

export default component.exports